import React from 'react'
import { LinkProps } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import {
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_ICON,
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_LINK,
  CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_TEXT,
} from 'utils/testing/testIDs'

import {
  AddMoreIcon,
  AddMoreLinkStyle,
  AddMoreText,
  StyledPlusIcon,
} from './styled-components'

const displayName = 'CustomPortfolioAddMoreLink'

export const CustomPortfolioAddMoreLink = React.forwardRef<
  HTMLAnchorElement,
  LinkProps
>(({ ...rest }, ref) => {
  const { getRemoteString } = useRemoteStrings()

  return (
    <AddMoreLinkStyle
      aria-label="add custom stocks and etfs to your account"
      data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_LINK}
      ref={ref}
      {...rest}
    >
      <AddMoreIcon>
        <StyledPlusIcon
          data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_ICON}
          height={12}
          icon={AcornsIcon.Icon.InlinePlus}
          width={12}
        />
      </AddMoreIcon>
      <AddMoreText data-testid={CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_TEXT}>
        {getRemoteString({ key: 'custom_portfolio.add_more_card.title' })}
      </AddMoreText>
    </AddMoreLinkStyle>
  )
})

CustomPortfolioAddMoreLink.displayName = displayName
